// @flow
import React from 'react'
import styled from 'styled-components'
import { mediaMax, mediaMin } from 'components/styles/_media'
import TopicItemCard, {
  type PropTypes as TopicItemCardTypes,
} from 'components/molecules/TopicListItem'
import Colors from 'components/styles/colors'
import type { Topic } from 'types/www/topic'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'

type PropTypes = {
  title: string,
  image: string,
  linkUrl: string,
}

export default (props: PropTypes) => {
  const imageUrl = imageURLWithTransform(props.image, {
    width: 670,
    height: 400,
    crop: 'fill',
  })
  return (
    <li className="smalllist__item">
      <a href={props.linkUrl}>
        <p className="smalllist__img">
          <OptimizedImage src={imageUrl} alt={props.title} />
        </p>
        <p className="smalllist__text">{props.title}</p>
      </a>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/TopicContentItem/FourColumn/index.jsx